class AddressProof {
    issueDate;
    rejectionMotive;
    proofType;
    status;
    constructor(addressProofData) {
        this.issueDate = addressProofData.issueDate;
        this.rejectionMotive = addressProofData.rejectionMotive;
        this.proofType = addressProofData.proofType;
        this.status = addressProofData.status;
    }
    isPending() {
        return this.status === 'pending';
    }
    isUploaded() {
        return this.status === 'uploaded';
    }
    isApproved() {
        return this.status === 'approved';
    }
    isRejected() {
        return this.status === 'rejected';
    }
    hasAddressProof() {
        return Boolean(this.proofType);
    }
    getRejectionMotive() {
        switch (this.rejectionMotive) {
            case 'document_is_not_an_address_proof':
                return 'Es inválido';
            case 'issue_date_mismatch':
                return 'Fecha de emisión incorrecta.';
            case 'unreadable':
                return 'Es ilegible';
            case 'expired':
                return 'No vigente';
            case 'inconsistent_data':
                return 'Inconsistencia en los datos';
            default:
                return 'El documento fue rechazado por un motivo desconocido';
        }
    }
}
export default AddressProof;
